var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotFromMuchMuch)?_c('a',{class:_vm.urlClass(),attrs:{"href":_vm.orderUrl()}},[_vm._v(" 訂單查詢 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }